import React from "react";
import moment from "moment";

function RecentActivity({ items, loading }) {
  const list = items || [];

  const render = (e, i) => {
    const when = e.at ? moment(e.at).fromNow() : "";
    if (e.type === "completed") {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <div className="fi" key={i}>
          <span className="ic ok">✓</span>
          <div>
            <div className="tx"><b>{e.learner}</b> completed <b>{e.material}</b></div>
            <div className="tm">{when}</div>
          </div>
        </div>
      );
    }
    if (e.type === "stuck") {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <div className="fi" key={i}>
          <span className="ic stk">!</span>
          <div>
            <div className="tx"><b>{e.learner}</b> got stuck{e.material ? <> on <b>{e.material}</b></> : ""}</div>
            <div className="tm">{when}</div>
          </div>
        </div>
      );
    }
    // joined
    return (
      // eslint-disable-next-line react/no-array-index-key
      <div className="fi" key={i}>
        <span className="ic jn">＋</span>
        <div>
          <div className="tx"><b>{e.learner}</b> joined your audience</div>
          <div className="tm">{when}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="dv-card">
      <div className="dv-head"><div><h3>Recent activity</h3></div><div className="sp" /><span className="dv-link">Live</span></div>
      {loading && !items ? (
        <div className="dv-empty">Loading…</div>
      ) : list.length === 0 ? (
        <div className="dv-empty">No recent activity in this period.</div>
      ) : (
        <div className="feed">{list.map(render)}</div>
      )}
    </div>
  );
}

export default RecentActivity;
